import { getDefaultSliderSettings } from './sliderUtils.js';
import { Swiper } from './swiper-src.min.js';

export default function initContainerFeatureSlider() {
  const swiperContainer = document.querySelector('.container-feature .swiper');
  if (!swiperContainer) return;

  const paginationAria = swiperContainer
    .querySelector('.swiper-pagination')
    .getAttribute('data-aria-pagination-bullet');

  new Swiper(swiperContainer, {
    ...getDefaultSliderSettings(swiperContainer),
    pagination: {
      el: '.swiper-pagination',
      type: 'bullets',
      clickable: true,
      renderBullet: (index, className) => {
        const bullet = document.createElement('span');
        bullet.className = className;
        bullet.setAttribute('type', 'button');
        bullet.setAttribute('aria-label', `${paginationAria} ${index + 1}`);
        return bullet.outerHTML;
      }
    },
    on: {
      paginationRender: () => {
        swiperContainer.querySelectorAll('.swiper-pagination-bullet').forEach(el => {
          el.setAttribute('tabindex', '-1');
        });
      },
      paginationUpdate: () => {
        swiperContainer.querySelectorAll('.swiper-pagination-bullet').forEach(el => {
          el.setAttribute('tabindex', '-1');
        });
      }
    }
  });
}
